/**
 * Carga diferida del mapa.
 *
 * MapLibre y PMTiles suman cerca de 800 KB. El cuestionario no los necesita:
 * la validación del GPS la hace la geometría cacheada, no el mapa. Cargarlos
 * sólo cuando se abre una vista con mapa deja el primer acceso en campo —que
 * suele ser sobre datos celulares— en un tamaño manejable.
 */

import { Suspense, lazy } from 'react';

import type { ClusterMapProps } from './ClusterMap';

const ClusterMapImpl = lazy(() =>
  import('./ClusterMap').then((module) => ({ default: module.ClusterMap })),
);

export function ClusterMap(props: ClusterMapProps) {
  return (
    <Suspense
      fallback={
        <div className={`map${props.full ? ' map--full' : ''}`}>
          <div className="map__placeholder">
            <div>
              <div className="spinner" style={{ margin: '0 auto 10px' }} />
              Cargando el mapa…
            </div>
          </div>
        </div>
      }
    >
      <ClusterMapImpl {...props} />
    </Suspense>
  );
}

export { TilesWarning } from './ClusterMap';
export type { MapMarker, ClusterMapProps } from './ClusterMap';
